import * as yup from 'yup'

export const managementSequentialSchema = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  tipoCodigoId: yup.string().required('El tipo codigo es obligatorio'),
  prefijo: yup.string().required('El prefijo es obligatorio'),
  cantidad: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .nullable()
    .required('La cantidad es obligatoria')
    .moreThan(0, 'La cantidad debe ser mayor que 0'),
})
